import * as React from "react";

/**
 * What a row needs to know about the value it edits. An action's parameter
 * and an agent's variable both fit: a name, whether it must be given, what
 * applies when it is not, and what it is for.
 */
export interface ParameterFieldParameter {
  name: string;
  required: boolean;
  default?: unknown;
  description?: string | null;
}

export interface ParameterFieldContextValue {
  parameter: ParameterFieldParameter;
  /** Id of the header's name, for a control that needs `aria-labelledby`. */
  labelId: string;
  error?: string;
}

export const ParameterFieldContext =
  React.createContext<ParameterFieldContextValue | null>(null);

/** Read inside a `ParameterField`: the parameter, the label id, the error. */
export function useParameterField(): ParameterFieldContextValue {
  const context = React.useContext(ParameterFieldContext);
  if (context === null) {
    throw new Error("useParameterField must be used inside ParameterField");
  }
  return context;
}
